import React from 'react'

import { NumberString, PriceString } from '@fourthwall/components'

import type { AnalyticsDataType } from '../../../../types'

type FormatChartValueParams = {
  value: number
  type?: AnalyticsDataType
}

export const formatChartValue = ({ value, type }: FormatChartValueParams) => {
  if (type === 'money') {
    return <PriceString value={value} />
  }

  if (type === 'number') {
    return <NumberString value={value} />
  }

  if (type === 'date') return ''

  if (type === 'percentage') {
    return `${value}%`
  }

  return value
}
